var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { FormLayout } from './form-layout';
export var Form = React.forwardRef(function (props, ref) {
    var onSubmit = props.onSubmit, children = props.children, rootProps = __rest(props, ["onSubmit", "children"]);
    var handleSubmit = function (e) {
        e.preventDefault();
        if (onSubmit) {
            onSubmit(e);
        }
    };
    return (React.createElement(FormLayout, __assign({ ref: ref }, { noValidate: true }, rootProps, { as: "form", onSubmit: onSubmit ? handleSubmit : undefined }), children));
});
